import CustomPageHeader from "../common/CustomPageHeader";
import CustomTabs from "@/components/CustomTabs";
import Profile from "./Profile";
import TeamManagement from "./TeamManagement";
import { ChevronRight, SettingsIcon, Users2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";
import { SlSettings } from "react-icons/sl";
import Users from "../customers/Users";
import { Coins, DataIcon, NotificationIcon, UserIcon } from "@/assets";
import { cn } from "@/lib/utils";
import { useAuthState } from "@/context";
import { Fragment, useEffect, useState } from "react";
import { Storage } from "@/services/storage-services";
const Settings = () => {
  const { state } = useAuthState();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (
      Storage.getItem("selectedMerchant")?.roleId === "merchant-owner" ||
      Storage.getItem("selectedMerchant")?.roleId === "merchant-admin"
    ) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [Storage.getItem("selectedMerchant")?.roleId]);

  return (
    <div className="flex flex-col gap-8 p-6">
      <CustomPageHeader
        title="Settings"
        description="Manage you and Treasura’s activities here"
      />
      <div className="grid grid-cols-3 gap-4">
        <div
          className={cn(
            "grid p-6 gap-2 bg-off-white-1 border-[1px] border-[#F4F0F7] rounded-[12px]"
          )}
        >
          <Link to="general" className="flex justify-between items-center">
            <div className="flex items-center gap-2 text-primary-3">
              <div className="w-12 h-12 rounded-full flex justify-center items-center bg-[#F7E5F7] text-2xl">
                <SlSettings />
              </div>
              <p className="text-lg font-semibold ">General</p>
            </div>
            <ChevronRight />
          </Link>
          <span className="text-sm text-gray-2">
            Update essential business details and company information
          </span>
        </div>
        <div
          className={cn(
            "grid p-6 gap-2 bg-off-white-1 border-[1px] border-[#F4F0F7] rounded-[12px]"
          )}
        >
          <Link to="teams" className="flex justify-between items-center">
            <div className="flex items-center gap-2 text-primary-3">
              <div className="w-12 h-12 rounded-full flex justify-center items-center bg-[#F7E5F7] text-2xl">
                <UserIcon />
              </div>
              <p className="text-lg font-semibold ">Teams</p>
            </div>
            <ChevronRight />
          </Link>
          <span className="text-sm text-gray-2">
            Add and manage team members with custom roles and permissions
          </span>
        </div>
        {!show ? null : (
          <Fragment>
            <div
              className={cn(
                "grid p-6 gap-2 bg-off-white-1 border-[1px] border-[#F4F0F7] rounded-[12px]"
              )}
            >
              <Link
                to="marketing"
                className="flex justify-between items-center"
              >
                <div className="flex items-center gap-2 text-primary-3">
                  <div className="w-12 h-12 rounded-full flex justify-center items-center bg-[#F7E5F7] text-2xl">
                    <NotificationIcon />
                  </div>
                  <p className="text-lg font-semibold ">Marketing</p>
                </div>
                <ChevronRight />
              </Link>
              <span className="text-sm text-gray-2">
                Set marketing preferences for your business and in-app marketing
              </span>
            </div>
            <div
              className={cn(
                "grid p-6 gap-2 bg-off-white-1 border-[1px] border-[#F4F0F7] rounded-[12px]"
              )}
            >
              <Link to="api" className="flex justify-between items-center">
                <div className="flex items-center gap-2 text-primary-3">
                  <div className="w-12 h-12 rounded-full flex justify-center items-center bg-[#F7E5F7] text-2xl">
                    <DataIcon />
                  </div>
                  <p className="text-lg font-semibold ">API Management</p>
                </div>
                <ChevronRight />
              </Link>
              <span className="text-sm text-gray-2">
                Set and manage your business API configurations
              </span>
            </div>
          </Fragment>
        )}

        <div
          className={cn(
            "grid p-6 gap-2 bg-off-white-1 border-[1px] border-[#F4F0F7] rounded-[12px]"
          )}
        >
          <Link to="asset-management" className="flex justify-between items-center">
            <div className="flex items-center gap-2 text-primary-3">
              <div className="w-12 h-12 rounded-full flex justify-center items-center bg-[#F7E5F7] text-2xl">
                <Coins />
              </div>
              <p className="text-lg font-semibold ">Asset Management</p>
            </div>
            <ChevronRight />
          </Link>
          <span className="text-sm text-gray-2">
            Manage associated asset supported for your users
          </span>
        </div>
      </div>
    </div>
  );
};

export default Settings;
